module.exports = __webpack_public_path__ + "img/s9-4.9dcda08e.jpg";